// -------------------------------- Pack section Update(upload and pack) correct Work---------------------

// import { useNavigate, useParams } from "react-router-dom";
// import { useAuth } from "../../components/context/Auth";
// import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
// import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
// import { formatDateTime, getStatusColor } from "../../Utils/Utils";
// import styles from "../dashboard/Dispatch.module.css";
// import fetchData from "../../APIsControll/apiControll";
// import {
//   useCallback,
//   useEffect,
//   useLayoutEffect,
//   useRef,
//   useState,
// } from "react";
// import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
// import { packingVoucherHeader } from "../../constants/constants";
// import {
//   CancelIcon2,
//   DownloadIcon,
//   LeftArrow,
//   NewEyeIcon,
//   Pack,
//   Printers,
//   SideBarDeliveryIcon,
//   SideBarInvoiceIcon,
// } from "../../components/icons/Icon";
// import { TemplateDone } from "../../components/icons/Icon2";
// import { ModalWrapper } from "../../exports";
// import Button from "../../components/updatedComponents/Dealers/Button";
// import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
// import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
// import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";

// import { useReactToPrint } from "react-to-print";

// import MoreDropdown from "../dispatchmanager/MoreDropdown";
// // import NewPackingSlip from "../dispatchmanager/NewPackingSlip";
// import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
// // import PackOrderModal from "../dispatchmanager/PackOrderModal";
// // import DeliveryDetailsModal from "../dispatchmanager/DeliveryDetailsModal";
// import PrintLabelModal from "../dispatchmanager/PrintLabelModal";
// import DownloadInvoicesModal from "../dispatchmanager/DownloadInvoicesModal";
// import AcceptOrderModal from "../dispatchmanager/AcceptOrderModal";
// import PackProdAndSaleVoucherModal from "../dispatchmanager/PackProdAndSaleVoucherModal";
// import ProdAndSalePackingSlip from "../dispatchmanager/ProdAndSalePackingSlip";
// import ProdAndSaleDeliveryDetailsModal from "../dispatchmanager/ProdAndSaleDeliveryDetailModal";

// const PackingProdAndSaleVoucher = () => {
//   const { show } = useToast();
//   const { mode, designations, managerId } = useAuth();
//   const { orderId } = useParams(); // route param renamed from orderId -> voucherId
//   const navigate = useNavigate();

//   const packingSlipRef = useRef(null);
//   const masterSummarySlipRef = useRef(null);
//   const summarySlipRef = useRef(null);

//   const [voucherData, setVoucherData] = useState({});
//   const [shippingAddress, setShippingAddress] = useState({});
//   const [itemDetails, setItemDetails] = useState([]);
//   const [partners, setPartners] = useState([]);
//   const [packingManagers, setPackingManagers] = useState([]);
//   const [selectedPM, setSelectedPM] = useState({
//     label: "Self",
//     value: managerId,
//   });
//   const [selectedPartner, setSelectedPartner] = useState({
//     label: "Select",
//     value: 0,
//   });
//   const [selectedPartnerDetails, setSelectedPartnerDetails] = useState({});
//   const [invoices, setInvoices] = useState([]); // kept for DownloadInvoicesModal parity; ProdAndSaleVoucher res has no `invoices` key today
//   const [paymentLink, setPaymentLink] = useState("");
//   const [modalContent, setModalContent] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   // single shippingInfo OBJECT here, not an array like the order flow
//   const [shippingInfo, setShippingInfo] = useState({});
//   const [packingSlipData, setPackingSlipData] = useState();

//   const getData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId, // <-- payload key changed from orderId
//       };
//       const data = await fetchData("dispatch/ProdAndSaleVoucher", apiData);

//       if (data.status === "success") {
//         const voucher = data.data.voucher;
//         setVoucherData(voucher);
//         setShippingAddress(voucher.shippingAddress || {});
//         setShippingInfo(voucher.shippingInfo || {});
//         setItemDetails(voucher.items || []);

//         setPackingManagers(
//           (data.data.pakingManagers || []).map((d) => ({
//             label: d.name,
//             value: d.managerId,
//             selectedWarehouse: d.selectedWarehouse,
//           })),
//         );
//         setSelectedPM({
//           label: voucher?.packermanager || "Self",
//           value: voucher?.pmId || managerId,
//         });

//         const partnerName = voucher?.shippingInfo?.partnerName || "";
//         const partnerMobile = voucher?.shippingInfo?.delPerMobile;

//         setSelectedPartner({
//           label: partnerName || "Select",
//           value: partnerMobile || partnerName || 0,
//         });
//         setPartners(data.data.courierPartners || []);
//         setInvoices(data.data.invoices || []);
//         return voucher?.shippingInfo?.packingImgs || [];
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   }, [managerId, orderId]);

//   const generatePaymentLink = useCallback(async () => {
//     setPaymentLink("");
//     if (!orderId) return;
//     try {
//       // NOTE: confirm with backend whether this endpoint accepts voucherId
//       // or needs a dedicated production/sale variant.
//       const apiData = { voucherId: orderId };
//       const result = await fetchData("receipt/generatePaymentLink", apiData);
//       if (result.status === "success" && result.shortUrl) {
//         setPaymentLink(result.shortUrl);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   }, [orderId]);

//   const generatePackingSlipData = useCallback(async () => {
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         // warehouseId: voucherData?.warehouseId,
//       };
//       // NOTE: confirm actual endpoint name for prod/sale packing slip data
//       const res = await fetchData("packing/prodAndSalePackingSlip", apiData);
//       if (res?.status === "success") {
//         setPackingSlipData(res);
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   }, [managerId, orderId]);

//   useLayoutEffect(() => {
//     if (!managerId) return;
//     getData();
//     generatePaymentLink();
//   }, [generatePaymentLink, getData, managerId]);

//   useEffect(() => {
//     if (!managerId || !voucherData?.warehouseId) return;
//     generatePackingSlipData();
//   }, [generatePackingSlipData, managerId, voucherData?.warehouseId]);

//   const acceptVoucher = async () => {
//     const partnerName =
//       selectedPartner.label === "Select" ? "" : selectedPartner.label;
//     const delPerMobile =
//       selectedPartnerDetails?.contactNumber ||
//       selectedPartnerDetails?.value ||
//       shippingInfo?.delPerMobile ||
//       null;

//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         pmId: selectedPM.value || managerId,
//         courierName: shippingInfo?.courierName,
//         partnerName:
//           selectedPartner.label === "Select"
//             ? voucherData?.partnerName
//             : selectedPartner.label,
//         delPerName: selectedPartner.label === "Select" ? "" : partnerName,
//         delPerMobile: delPerMobile,
//         delTrackingNo: selectedPartnerDetails?.trackingNumber || "",
//         delTrackingUrl: selectedPartnerDetails?.trackingUrl || "",
//         // warehouseId: voucherData?.warehouseId,
//       };

//       // NOTE: swap for the real accept endpoint for prod/sale vouchers once known
//       const res = await fetchData("dispatch/acceptProdAndSaleVoucher", apiData);
//       if (res.status === "success") {
//         show(res.msg, "success");
//         getData();
//       }
//       if (res.status === "failed") {
//         show(res.msg, "error");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const reqForInvoice = async () => {
//     try {
//       const apiData = { managerId: managerId, voucherId: orderId };
//       const data = await fetchData("invoice/urgentUploadReq", apiData);
//       if (data.status === "success") {
//         show("Request sent successfully", "success");
//         getData();
//       }
//       if (data.status === "failed") {
//         show("Unable to send Request", "error");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const generateLabelData = async (packs) => {
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         // qtyPacks: packs,
//         // delPerName: shippingInfo?.delPerName,
//         // delPerMobile: shippingInfo?.delPerMobile,
//         // delTrackingNo: shippingInfo?.delTrackingNo,
//         // delTrackingUrl: shippingInfo?.delTrackingUrl,
//         // warehouseId: voucherData?.warehouseId,
//       };
//       const res = await fetchData("dispatch/printPSLabel", apiData);
//       if (res.status === "success") {
//         show("Label data generated, Opening File!", "success");
//         closeModal();
//       }
//       if (res.status === "failed") {
//         show("Unable to generate Label data", "error");
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleCancelVoucher = async (cancelReason) => {
//     try {
//       const apiData = {
//         managerId: managerId,
//         voucherId: orderId,
//         cancelReason: cancelReason,
//         warehouseId: voucherData?.warehouseId,
//       };
//       const res = await fetchData("dispatch/cancelOrder", apiData);
//       if (res.status === "success") {
//         show("Voucher cancelled successfully!", "success");
//         getData();
//       } else {
//         show(res.msg || "Something went wrong", "error");
//       }
//     } catch (error) {
//       console.error("Cancel voucher failed:", error);
//     }
//   };

//   const openModal = (content) => {
//     setIsModalOpen(true);
//     setModalContent(content);
//   };
//   const closeModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null);
//   };

//   const openAcceptOrderModal = () => {
//     openModal(
//       <AcceptOrderModal
//         heading={"Accept Voucher"}
//         centerHeading={"Are you sure you want to accept this voucher?"}
//         targetWord={"voucher"}
//         handleSubmit={acceptVoucher}
//         handleCloseModal={closeModal}
//       />,
//     );
//   };

//   // const openPackOrderModal = () => {
//   //   openModal(
//   //     <PackOrderModal
//   //       mode={mode}
//   //       closeModal={closeModal}
//   //       managerId={managerId}
//   //       orderId={orderId}
//   //       getData={getData}
//   //       warehousename={voucherData?.warehousename}
//   //       warehouseId={voucherData?.warehouseId}
//   //       isSuperAdmin={isSuperAdmin}
//   //     />,
//   //   );
//   // };

//   const openPackOrderModal = () => {
//     openModal(
//       <PackProdAndSaleVoucherModal
//         mode={mode}
//         closeModal={closeModal}
//         managerId={managerId}
//         orderId={orderId}
//         getData={getData}
//         packingImgs={shippingInfo?.packingImgs || []}
//       />,
//     );
//   };

//   // const openDeliveryDetailsModal = () => {
//   //   openModal(
//   //     <DeliveryDetailsModal
//   //       mode={mode}
//   //       closeModal={closeModal}
//   //       managerId={managerId}
//   //       orderId={orderId}
//   //       orderData={voucherData}
//   //       partners={filteredPartners}
//   //       getData={getData}
//   //       paymentLink={paymentLink}
//   //       filteredShippingInfo={[shippingInfo]}
//   //       warehouseName={voucherData?.warehousename}
//   //       warehouseId={voucherData?.warehouseId}
//   //       allPartners={partners}
//   //     />,
//   //   );
//   // };

//   const openDeliveryDetailsModal = () => {
//     openModal(
//       <ProdAndSaleDeliveryDetailsModal
//         mode={mode}
//         closeModal={closeModal}
//         managerId={managerId}
//         orderId={orderId}
//         orderData={voucherData}
//         partners={filteredPartners}
//         getData={getData}
//         paymentLink={paymentLink}
//         filteredShippingInfo={[shippingInfo]}
//         warehouseName={voucherData?.warehousename}
//         warehouseId={voucherData?.warehouseId}
//         allPartners={partners}
//       />,
//     );
//   };

//   const openPrintLabelModal = () => {
//     openModal(
//       <PrintLabelModal
//         mode={mode}
//         closeModal={closeModal}
//         packs={voucherData.packingQty}
//         submit={(packs) => generateLabelData(packs)}
//         orderData={voucherData}
//       />,
//     );
//   };

//   const openCancelOrderModal = () => {
//     openModal(
//       <RequestForCancelModal
//         mode={mode}
//         handleCloseModal={closeModal}
//         handleSubmit={(reason) => {
//           if (reason.length < 20) {
//             show("Cancel reason must be greater than 10 letters!", "warning");
//           } else {
//             handleCancelVoucher(reason);
//           }
//         }}
//         type={"dispatch"}
//       />,
//     );
//   };

//   const openDownloadInvoiceModal = () => {
//     openModal(
//       <DownloadInvoicesModal
//         mode={mode}
//         closeModal={closeModal}
//         invoices={invoices}
//       />,
//     );
//   };

//   const filteredPartners = partners?.filter((partner) => {
//     const isSelf = partner?.partnerName === "Self";
//     const isRapido = partner?.partnerName === "Rapido & Porter";
//     const hasSelectedWarehouse = partner?.selectedWarehouse?.some(
//       (w) => w?.warehouseId === voucherData?.warehouseId,
//     );
//     return isSelf || isRapido || hasSelectedWarehouse;
//   });

//   const isSuperAdmin = designations.includes("superadmin");

//   // dispatchStatus lives directly on the voucher (single value), not per shippingInfo entry
//   const status = voucherData?.dispatchStatus;

//   const isNewOrder = status === "New Order";
//   const isInProgress = status === "In Progress";
//   const isPacked = status === "Packed";
//   const isDispatched = status === "Dispatched";
//   const isCompleted = status === "Completed";

//   const canShowPackingSlip = isInProgress || isPacked || isDispatched;

//   const showReqForInvoiceBtn = [
//     "Pending",
//     "OrderReturn",
//     "Reupload",
//     "Cancelled",
//   ].includes(voucherData?.invoiceStatus);
//   const showInvoiceReqSentBtn = voucherData?.invoiceStatus === "Urgent";
//   const showDownloadInvoiceBtn = voucherData?.invoiceStatus === "Uploaded";

//   useEffect(() => {
//     const partnerName = shippingInfo?.partnerName;
//     const partnerMobile = shippingInfo?.delPerMobile;

//     if (!partnerName) {
//       setSelectedPartner({
//         label: "Select",
//         value: 0,
//       });
//       setSelectedPartnerDetails(null);
//       return;
//     }

//     setSelectedPartner({
//       label: partnerName,
//       value: partnerMobile || partnerName,
//     });

//     const foundPartner =
//       partners?.find(
//         (p) =>
//           p?.contactNumber && String(p.contactNumber) === String(partnerMobile),
//       ) ||
//       partners?.find(
//         (p) =>
//           p?.partnerName?.trim()?.toLowerCase() ===
//           partnerName?.trim()?.toLowerCase(),
//       );

//     setSelectedPartnerDetails(foundPartner || null);
//   }, [shippingInfo, partners]);

//   const routeName = "Packing Voucher / " + orderId;

//   const printPackingSlip = useReactToPrint({
//     content: () => packingSlipRef.current,
//   });
//   const printMasterSummarySlip = useReactToPrint({
//     content: () => masterSummarySlipRef.current,
//   });
//   const printSummarySlip = useReactToPrint({
//     content: () => summarySlipRef.current,
//   });

//   return (
//     <div
//       className={styles.dispatch}
//       style={{
//         backgroundColor: mode && "#2C2E33",
//         borderColor: mode && "#2C2E33",
//       }}
//     >
//       <ModalWrapper
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         noBtn
//       >
//         {modalContent}
//       </ModalWrapper>

//       <div className={styles.dispatch_top}>
//         <div>
//           <TopTabBar text={routeName} />
//         </div>
//         <div className={styles.dispatch_right}>
//           <TextElement
//             label={"Voucher No. & Date:"}
//             labelColor={mode ? "#fff" : "#646B88"}
//             value={
//               voucherData.voucherId +
//               " / " +
//               formatDateTime(voucherData.voucherDate)
//             }
//             valueColor={mode ? "#fff" : "#646B88"}
//             fontSize={"12px"}
//             type={"order"}
//           />
//           <TextElement
//             label={"Created By:"}
//             labelColor={mode ? "#fff" : "#646B88"}
//             value={voucherData.createdBy}
//             valueColor={mode ? "#fff" : "#646B88"}
//             fontSize={"12px"}
//             type={"order"}
//           />
//           <TextElement
//             label={"Order Manager:"}
//             labelColor={mode ? "#fff" : "#646B88"}
//             value={voucherData.ordermanager}
//             valueColor={mode ? "#fff" : "#646B88"}
//             fontSize={"12px"}
//             type={"order"}
//           />
//           <TextElement
//             label={"Status:"}
//             labelColor={mode ? "#fff" : "#646B88"}
//             value={status}
//             valueColor={getStatusColor(status)}
//             fontSize={"12px"}
//             type={"order"}
//           />
//         </div>
//       </div>

//       {loading ? (
//         <Skeleton
//           lines={1}
//           thickness={15}
//           additionalStyles={{
//             marginBottom: "0px",
//             marginTop: "0px",
//             borderRadius: "15px",
//           }}
//         />
//       ) : (
//         <div
//           className={styles.det_1}
//           style={{
//             backgroundColor: mode && "#1B1D21",
//             borderColor: mode && "#1B1D21",
//           }}
//         >
//           <div className={styles.det_1_sub}>
//             <p style={{ color: mode && "#FFFFFF" }}>
//               {voucherData.storeName} / {shippingAddress.name}
//             </p>
//           </div>

//           <div className={styles.det_1_sub}>
//             <div className={styles.det_1_sub_2}>
//               <TextElement
//                 label={"Address:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={
//                   shippingAddress.street +
//                   ", " +
//                   shippingAddress.city +
//                   ", " +
//                   shippingAddress.district +
//                   ", " +
//                   shippingAddress.state +
//                   ", " +
//                   shippingAddress.pincode
//                 }
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Contact:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={voucherData.whatsapp || voucherData.mobile}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Email:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={voucherData.email}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"GSTUIN :"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={voucherData.gstuin}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//             </div>

//             <div className={styles.det_1_sub_2}>
//               <TextElement
//                 label={"Courier Name:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={shippingInfo?.courierName}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Delivery Method:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={shippingInfo?.methodName}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Voucher Type:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={voucherData?.voucherType}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Dispatch Warehouse:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={voucherData?.warehousename}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//               <TextElement
//                 label={"Packer:"}
//                 labelColor={mode ? "#fff" : "#646B88"}
//                 value={selectedPM?.label}
//                 valueColor={mode ? "#fff" : "#646B88"}
//                 fontSize={"14px"}
//                 fontWeight={"400"}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       <ul className={styles.p_table}>
//         <div
//           className={styles.p_table_header_con}
//           style={{ visibility: loading && "hidden" }}
//         >
//           <li
//             className={`${styles.p_table_header} ${mode ? styles.p_table_header_dark : ""}`}
//           >
//             {packingVoucherHeader?.map((h, index) => (
//               <div className={styles.entry_2} key={`${h}-${index}`}>
//                 {h}
//               </div>
//             ))}
//           </li>
//         </div>

//         {itemDetails?.map((item, index) => (
//           <div className={styles.p_table_list} key={item.itemNo + "-" + index}>
//             {loading ? (
//               <Skeleton
//                 lines={itemDetails?.length === 1 ? 1 : itemDetails?.length / 2}
//                 thickness={5}
//                 additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
//               />
//             ) : (
//               <li
//                 className={`${styles.p_table_row} ${mode ? styles.p_table_row_dark : ""}`}
//               >
//                 <div className={styles.entry_2}> {index + 1} </div>
//                 <div className={styles.entry_2}>{item.itemNo}</div>
//                 <div className={styles.entry_2}> {item.product_name} </div>
//                 <div className={styles.entry_2}>
//                   {voucherData?.warehousename}
//                 </div>
//                 <div className={styles.entry_2}>{item.qty}</div>
//                 <div className={styles.entry_2}> {item.unit}</div>
//               </li>
//             )}
//           </div>
//         ))}
//       </ul>

//       <footer className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
//         <div className={styles.footer_left}>
//           <TextElement
//             label={"Total Items:"}
//             labelColor={mode ? "#fff" : "#646B88"}
//             value={itemDetails?.length}
//             valueColor={mode ? "#fff" : "#646B88"}
//             fontSize={"14px"}
//             fontWeight={"400"}
//           />
//           <div className={styles.footer_dds}>
//             <div>
//               <VerticalDropDown2
//                 height={"37px"}
//                 fontSize={"12px"}
//                 dropDownText={"Select"}
//                 label={"Select Packer"}
//                 value={selectedPM}
//                 options={packingManagers}
//                 onchange={(option) => setSelectedPM(option)}
//                 openUpwards={true}
//                 disableOpen={!isNewOrder}
//               />
//             </div>
//             <div>
//               <VerticalDropDown2
//                 height={"37px"}
//                 fontSize={"12px"}
//                 label={"Select Partner"}
//                 value={selectedPartner}
//                 options={filteredPartners?.map((p) => ({
//                   label: p?.partnerName,
//                   value: p?.contactNumber || p?.partnerName,
//                 }))}
//                 onchange={(v) => {
//                   setSelectedPartner(v);

//                   const foundPartner =
//                     partners?.find(
//                       (p) =>
//                         p?.contactNumber &&
//                         String(p.contactNumber) === String(v?.value),
//                     ) ||
//                     partners?.find(
//                       (p) =>
//                         p?.partnerName?.trim()?.toLowerCase() ===
//                         v?.label?.trim()?.toLowerCase(),
//                     );

//                   setSelectedPartnerDetails(foundPartner || null);
//                 }}
//                 openUpwards={true}
//                 disableOpen={isDispatched || isCompleted}
//               />
//             </div>
//           </div>
//         </div>

//         {!loading && (
//           <div className={styles.btn_wrapper}>
//             {canShowPackingSlip && (
//               <MoreDropdown
//                 mode={mode}
//                 // isSuperAdmin={isSuperAdmin}
//                 onSummaryClick={() => printMasterSummarySlip()}
//                 onSlipClick={() => printSummarySlip()}
//               />
//             )}

//             <div>
//               <Button
//                 buttonIcon={<LeftArrow color={"#FFFFFF"} />}
//                 buttonText={"Back"}
//                 buttonBgColor={"#000000"}
//                 buttonTextColor={"#ffffff"}
//                 buttonClick={() => navigate(-1)}
//               />
//             </div>

//             {isNewOrder && (
//               <div>
//                 <Button
//                   buttonIcon={<TemplateDone />}
//                   buttonText={"Accept"}
//                   buttonBgColor={"#4164E3"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={openAcceptOrderModal}
//                 />
//               </div>
//             )}

//             {(isInProgress || isPacked || isDispatched) && (
//               <div>
//                 <Button
//                   buttonIcon={<CancelIcon2 />}
//                   buttonText={"Cancel Order"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={openCancelOrderModal}
//                 />
//               </div>
//             )}

//             {canShowPackingSlip && (
//               <div>
//                 <Button
//                   buttonIcon={<Printers color="#FFFFFF" />}
//                   buttonText={"Packing Slip"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={printPackingSlip}
//                 />
//               </div>
//             )}

//             {isPacked && (
//               <div>
//                 <Button
//                   buttonIcon={<SideBarDeliveryIcon color="#FFFFFF" />}
//                   buttonText={"Delivery Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={openDeliveryDetailsModal}
//                 />
//               </div>
//             )}

//             {(isDispatched || isCompleted) && (
//               <div>
//                 <Button
//                   buttonIcon={<NewEyeIcon />}
//                   buttonText={"Dispatch Details"}
//                   buttonBgColor={"#000000"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={() =>
//                     navigate(
//                       "/dispatch/prodAndSaleDetails/" +
//                         orderId +
//                         "/" +
//                         voucherData?.warehouseId,
//                     )
//                   }
//                 />
//               </div>
//             )}

//             {!isNewOrder && (
//               <>
//                 {(showReqForInvoiceBtn || isSuperAdmin) && (
//                   <div>
//                     <Button
//                       buttonTextColor={"#FFFFFF"}
//                       buttonBgColor={"#4164E3"}
//                       buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
//                       buttonText={"Request for Invoice"}
//                       buttonClick={reqForInvoice}
//                     />
//                   </div>
//                 )}
//                 {showInvoiceReqSentBtn && (
//                   <div>
//                     <Button
//                       buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
//                       buttonTextColor={"#FFFFFF"}
//                       buttonBgColor={"#FF9B04"}
//                       buttonText={"Invoice Pending"}
//                     />
//                   </div>
//                 )}
//                 {showDownloadInvoiceBtn && (
//                   <div>
//                     <Button
//                       buttonTextColor={"#FFFFFF"}
//                       buttonBgColor={"#4164E3"}
//                       buttonIcon={<DownloadIcon />}
//                       buttonText={"Download Invoice"}
//                       buttonClick={openDownloadInvoiceModal}
//                     />
//                   </div>
//                 )}
//               </>
//             )}

//             {(isPacked || isDispatched || isCompleted) && (
//               <div>
//                 <Button
//                   buttonIcon={<Printers color="#FFFFFF" />}
//                   buttonText={"Label"}
//                   buttonBgColor={"#4164E3"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={openPrintLabelModal}
//                 />
//               </div>
//             )}

//             {isInProgress && (
//               <div>
//                 <Button
//                   buttonIcon={<Pack />}
//                   buttonText={"Pack"}
//                   buttonBgColor={"#4164E3"}
//                   buttonTextColor={"#ffffff"}
//                   buttonClick={openPackOrderModal}
//                 />
//               </div>
//             )}
//           </div>
//         )}
//       </footer>

//       <div style={{ display: "none" }}>
//         {/* <NewPackingSlip
//           ref={packingSlipRef}
//           packingSlipData={packingSlipData}
//           order={voucherData}
//           currentWarehouse={voucherData?.warehouseId}
//           filterItem={itemDetails}
//           totalQty={itemDetails.length}
//         /> */}

//         <ProdAndSalePackingSlip
//           ref={packingSlipRef}
//           packingSlipData={packingSlipData}
//           order={voucherData}
//           currentWarehouse={voucherData?.warehouseId}
//           filterItem={itemDetails}
//           totalQty={itemDetails.length}
//         />
//       </div>

//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={masterSummarySlipRef}
//           summarySlipData={packingSlipData}
//         />
//       </div>

//       <div style={{ display: "none" }}>
//         <NewSummarySlip
//           ref={summarySlipRef}
//           summarySlipData={packingSlipData}
//           currentWarehouse={voucherData?.warehouseId}
//           currentWarehouseName={voucherData?.warehousename}
//         />
//       </div>
//     </div>
//   );
// };

// export default PackingProdAndSaleVoucher;

// -------------------------------- Pack section Update(upload and pack) and Packing Slip---------------------

import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../components/context/Auth";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";
import TopTabBar from "../../components/updatedComponents/Tanolet/TopTabBar";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import styles from "../dashboard/Dispatch.module.css";
import fetchData from "../../APIsControll/apiControll";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { packingVoucherHeader } from "../../constants/constants";
import {
  CancelIcon2,
  DownloadIcon,
  LeftArrow,
  NewEyeIcon,
  Pack,
  Printers,
  SideBarDeliveryIcon,
  SideBarInvoiceIcon,
} from "../../components/icons/Icon";
import { TemplateDone } from "../../components/icons/Icon2";
import { ModalWrapper } from "../../exports";
import Button from "../../components/updatedComponents/Dealers/Button";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import { useToast } from "../../components/updatedComponents/Toaster/Toaster";
import RequestForCancelModal from "../../components/updatedComponents/OrderManager/RequestForCancelModal";

import { useReactToPrint } from "react-to-print";

import MoreDropdown from "../dispatchmanager/MoreDropdown";
import NewSummarySlip from "../dispatchmanager/NewSummarySlip";
import PrintLabelModal from "../dispatchmanager/PrintLabelModal";
import DownloadInvoicesModal from "../dispatchmanager/DownloadInvoicesModal";
import AcceptOrderModal from "../dispatchmanager/AcceptOrderModal";
import PackProdAndSaleVoucherModal from "../dispatchmanager/PackProdAndSaleVoucherModal";
import ProdAndSalePackingSlip from "../dispatchmanager/ProdAndSalePackingSlip";
import ProdAndSaleDeliveryDetailsModal from "../dispatchmanager/ProdAndSaleDeliveryDetailModal";

const PackingProdAndSaleVoucher = () => {
  const { show } = useToast();
  const { mode, designations, managerId } = useAuth();
  const { orderId } = useParams(); // this is the voucherId
  const navigate = useNavigate();

  const packingSlipRef = useRef(null);
  const masterSummarySlipRef = useRef(null);
  const summarySlipRef = useRef(null);

  const [voucherData, setVoucherData] = useState({});
  const [shippingAddress, setShippingAddress] = useState({});
  const [itemDetails, setItemDetails] = useState([]);
  const [partners, setPartners] = useState([]);
  const [packingManagers, setPackingManagers] = useState([]);
  const [selectedPM, setSelectedPM] = useState({
    label: "Self",
    value: managerId,
  });
  const [selectedPartner, setSelectedPartner] = useState({
    label: "Select",
    value: 0,
  });
  const [selectedPartnerDetails, setSelectedPartnerDetails] = useState({});
  const [invoices, setInvoices] = useState([]);
  const [paymentLink, setPaymentLink] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [shippingInfo, setShippingInfo] = useState({});
  const [packingSlipData, setPackingSlipData] = useState();
  const [slipLoading, setSlipLoading] = useState(false);
  const [printTarget, setPrintTarget] = useState(null); // "slip" | "master" | "summary"

  const getData = useCallback(async () => {
    setLoading(true);
    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
      };
      const data = await fetchData("dispatch/ProdAndSaleVoucher", apiData);

      if (data.status === "success") {
        const voucher = data.data.voucher;
        setVoucherData(voucher);
        setShippingAddress(voucher.shippingAddress || {});
        setShippingInfo(voucher.shippingInfo || {});
        setItemDetails(voucher.items || []);

        setPackingManagers(
          (data.data.pakingManagers || []).map((d) => ({
            label: d.name,
            value: d.managerId,
            selectedWarehouse: d.selectedWarehouse,
          })),
        );
        setSelectedPM({
          label: voucher?.packermanager || "Self",
          value: voucher?.pmId || managerId,
        });

        const partnerName = voucher?.shippingInfo?.partnerName || "";
        const partnerMobile = voucher?.shippingInfo?.delPerMobile;

        setSelectedPartner({
          label: partnerName || "Select",
          value: partnerMobile || partnerName || 0,
        });
        setPartners(data.data.courierPartners || []);
        setInvoices(data.data.invoices || []);
        return voucher?.shippingInfo?.packingImgs || [];
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [managerId, orderId]);

  const generatePaymentLink = useCallback(async () => {
    setPaymentLink("");
    if (!orderId) return;
    try {
      const apiData = { voucherId: orderId };
      const result = await fetchData("receipt/generatePaymentLink", apiData);
      if (result.status === "success" && result.shortUrl) {
        setPaymentLink(result.shortUrl);
      }
    } catch (error) {
      console.error(error);
    }
  }, [orderId]);

  // Called only when a print button is clicked (no auto-fetch on page load).
  // Returns the response so the click handler knows if it worked.
  const generatePackingSlipData = useCallback(async () => {
    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
        // warehouseId: voucherData?.warehouseId,
      };
      const res = await fetchData("packing/prodAndSalePackingSlip", apiData);
      if (res?.status === "success") {
        setPackingSlipData(res);
        return res;
      }
      show(res?.msg || "Unable to get packing slip data", "error");
      return null;
    } catch (error) {
      console.error(error);
      show("Unable to get packing slip data", "error");
      return null;
    }
  }, [managerId, orderId, show]);

  useLayoutEffect(() => {
    if (!managerId) return;
    getData();
    generatePaymentLink();
  }, [generatePaymentLink, getData, managerId]);

  const acceptVoucher = async () => {
    const partnerName =
      selectedPartner.label === "Select" ? "" : selectedPartner.label;
    const delPerMobile =
      selectedPartnerDetails?.contactNumber ||
      selectedPartnerDetails?.value ||
      shippingInfo?.delPerMobile ||
      null;

    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
        pmId: selectedPM.value || managerId,
        courierName: shippingInfo?.courierName,
        partnerName:
          selectedPartner.label === "Select"
            ? voucherData?.partnerName
            : selectedPartner.label,
        delPerName: selectedPartner.label === "Select" ? "" : partnerName,
        delPerMobile: delPerMobile,
        delTrackingNo: selectedPartnerDetails?.trackingNumber || "",
        delTrackingUrl: selectedPartnerDetails?.trackingUrl || "",
        // warehouseId: voucherData?.warehouseId,
      };

      const res = await fetchData("dispatch/acceptProdAndSaleVoucher", apiData);
      if (res.status === "success") {
        show(res.msg, "success");
        getData();
      }
      if (res.status === "failed") {
        show(res.msg, "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reqForInvoice = async () => {
    try {
      const apiData = { managerId: managerId, voucherId: orderId };
      const data = await fetchData("invoice/urgentUploadReq", apiData);
      if (data.status === "success") {
        show("Request sent successfully", "success");
        getData();
      }
      if (data.status === "failed") {
        show("Unable to send Request", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const generateLabelData = async (packs) => {
    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
        // qtyPacks: packs,
        // delPerName: shippingInfo?.delPerName,
        // delPerMobile: shippingInfo?.delPerMobile,
        // delTrackingNo: shippingInfo?.delTrackingNo,
        // delTrackingUrl: shippingInfo?.delTrackingUrl,
        // warehouseId: voucherData?.warehouseId,
      };
      const res = await fetchData("dispatch/printPSLabel", apiData);
      if (res.status === "success") {
        show("Label data generated, Opening File!", "success");
        closeModal();
      }
      if (res.status === "failed") {
        show("Unable to generate Label data", "error");
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCancelVoucher = async (cancelReason) => {
    try {
      const apiData = {
        managerId: managerId,
        voucherId: orderId,
        cancelReason: cancelReason,
        warehouseId: voucherData?.warehouseId,
      };
      const res = await fetchData("dispatch/cancelOrder", apiData);
      if (res.status === "success") {
        show("Voucher cancelled successfully!", "success");
        getData();
      } else {
        show(res.msg || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Cancel voucher failed:", error);
    }
  };

  const openModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  const openAcceptOrderModal = () => {
    openModal(
      <AcceptOrderModal
        heading={"Accept Voucher"}
        centerHeading={"Are you sure you want to accept this voucher?"}
        targetWord={"voucher"}
        handleSubmit={acceptVoucher}
        handleCloseModal={closeModal}
      />,
    );
  };

  const openPackOrderModal = () => {
    openModal(
      <PackProdAndSaleVoucherModal
        mode={mode}
        closeModal={closeModal}
        managerId={managerId}
        orderId={orderId}
        getData={getData}
        packingImgs={shippingInfo?.packingImgs || []}
      />,
    );
  };

  const openDeliveryDetailsModal = () => {
    openModal(
      <ProdAndSaleDeliveryDetailsModal
        mode={mode}
        closeModal={closeModal}
        managerId={managerId}
        orderId={orderId}
        orderData={voucherData}
        partners={filteredPartners}
        getData={getData}
        paymentLink={paymentLink}
        filteredShippingInfo={[shippingInfo]}
        warehouseName={voucherData?.warehousename}
        warehouseId={voucherData?.warehouseId}
        allPartners={partners}
      />,
    );
  };

  const openPrintLabelModal = () => {
    openModal(
      <PrintLabelModal
        mode={mode}
        closeModal={closeModal}
        packs={voucherData.packingQty}
        submit={(packs) => generateLabelData(packs)}
        orderData={voucherData}
      />,
    );
  };

  const openCancelOrderModal = () => {
    openModal(
      <RequestForCancelModal
        mode={mode}
        handleCloseModal={closeModal}
        handleSubmit={(reason) => {
          if (reason.length < 20) {
            show("Cancel reason must be greater than 10 letters!", "warning");
          } else {
            handleCancelVoucher(reason);
          }
        }}
        type={"dispatch"}
      />,
    );
  };

  const openDownloadInvoiceModal = () => {
    openModal(
      <DownloadInvoicesModal
        mode={mode}
        closeModal={closeModal}
        invoices={invoices}
      />,
    );
  };

  const filteredPartners = partners?.filter((partner) => {
    const isSelf = partner?.partnerName === "Self";
    const isRapido = partner?.partnerName === "Rapido & Porter";
    const hasSelectedWarehouse = partner?.selectedWarehouse?.some(
      (w) => w?.warehouseId === voucherData?.warehouseId,
    );
    return isSelf || isRapido || hasSelectedWarehouse;
  });

  const isSuperAdmin = designations.includes("superadmin");

  // dispatchStatus lives directly on the voucher (single value)
  const status = voucherData?.dispatchStatus;

  const isNewOrder = status === "New Order";
  const isInProgress = status === "In Progress";
  const isPacked = status === "Packed";
  const isDispatched = status === "Dispatched";
  const isCompleted = status === "Completed";

  const canShowPackingSlip = isInProgress || isPacked || isDispatched;

  const showReqForInvoiceBtn = [
    "Pending",
    "OrderReturn",
    "Reupload",
    "Cancelled",
  ].includes(voucherData?.invoiceStatus);
  const showInvoiceReqSentBtn = voucherData?.invoiceStatus === "Urgent";
  const showDownloadInvoiceBtn = voucherData?.invoiceStatus === "Uploaded";

  useEffect(() => {
    const partnerName = shippingInfo?.partnerName;
    const partnerMobile = shippingInfo?.delPerMobile;

    if (!partnerName) {
      setSelectedPartner({
        label: "Select",
        value: 0,
      });
      setSelectedPartnerDetails(null);
      return;
    }

    setSelectedPartner({
      label: partnerName,
      value: partnerMobile || partnerName,
    });

    const foundPartner =
      partners?.find(
        (p) =>
          p?.contactNumber && String(p.contactNumber) === String(partnerMobile),
      ) ||
      partners?.find(
        (p) =>
          p?.partnerName?.trim()?.toLowerCase() ===
          partnerName?.trim()?.toLowerCase(),
      );

    setSelectedPartnerDetails(foundPartner || null);
  }, [shippingInfo, partners]);

  const routeName = "Packing Voucher / " + orderId;

  const printPackingSlip = useReactToPrint({
    content: () => packingSlipRef.current,
  });
  const printMasterSummarySlip = useReactToPrint({
    content: () => masterSummarySlipRef.current,
  });
  const printSummarySlip = useReactToPrint({
    content: () => summarySlipRef.current,
  });

  // Click -> hit API -> store data -> trigger print after re-render
  const handlePrintClick = async (target) => {
    if (slipLoading) return;
    setSlipLoading(true);
    const res = await generatePackingSlipData();
    setSlipLoading(false);
    if (res) setPrintTarget(target);
  };

  // Runs after the hidden slip components re-render with the fresh data
  useEffect(() => {
    if (!printTarget) return;
    if (printTarget === "slip") printPackingSlip();
    if (printTarget === "master") printMasterSummarySlip();
    if (printTarget === "summary") printSummarySlip();
    setPrintTarget(null);
  }, [printTarget]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className={styles.dispatch}
      style={{
        backgroundColor: mode && "#2C2E33",
        borderColor: mode && "#2C2E33",
      }}
    >
      <ModalWrapper
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        noBtn
      >
        {modalContent}
      </ModalWrapper>

      <div className={styles.dispatch_top}>
        <div>
          <TopTabBar text={routeName} />
        </div>
        <div className={styles.dispatch_right}>
          <TextElement
            label={"Voucher No. & Date:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={
              voucherData.voucherId +
              " / " +
              formatDateTime(voucherData.voucherDate)
            }
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Created By:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={voucherData.createdBy}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Order Manager:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={voucherData.ordermanager}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"12px"}
            type={"order"}
          />
          <TextElement
            label={"Status:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={status}
            valueColor={getStatusColor(status)}
            fontSize={"12px"}
            type={"order"}
          />
        </div>
      </div>

      {loading ? (
        <Skeleton
          lines={1}
          thickness={15}
          additionalStyles={{
            marginBottom: "0px",
            marginTop: "0px",
            borderRadius: "15px",
          }}
        />
      ) : (
        <div
          className={styles.det_1}
          style={{
            backgroundColor: mode && "#1B1D21",
            borderColor: mode && "#1B1D21",
          }}
        >
          <div className={styles.det_1_sub}>
            <p style={{ color: mode && "#FFFFFF" }}>
              {voucherData.storeName} / {shippingAddress.name}
            </p>
          </div>

          <div className={styles.det_1_sub}>
            <div className={styles.det_1_sub_2}>
              <TextElement
                label={"Address:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={
                  shippingAddress.street +
                  ", " +
                  shippingAddress.city +
                  ", " +
                  shippingAddress.district +
                  ", " +
                  shippingAddress.state +
                  ", " +
                  shippingAddress.pincode
                }
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Contact:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={voucherData.whatsapp || voucherData.mobile}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Email:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={voucherData.email}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"GSTUIN :"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={voucherData.gstuin}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
            </div>

            <div className={styles.det_1_sub_2}>
              <TextElement
                label={"Courier Name:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={shippingInfo?.courierName}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Delivery Method:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={shippingInfo?.methodName}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Voucher Type:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={voucherData?.voucherType}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Dispatch Warehouse:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={voucherData?.warehousename}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
              <TextElement
                label={"Packer:"}
                labelColor={mode ? "#fff" : "#646B88"}
                value={selectedPM?.label}
                valueColor={mode ? "#fff" : "#646B88"}
                fontSize={"14px"}
                fontWeight={"400"}
              />
            </div>
          </div>
        </div>
      )}

      <ul className={styles.p_table}>
        <div
          className={styles.p_table_header_con}
          style={{ visibility: loading && "hidden" }}
        >
          <li
            className={`${styles.p_table_header} ${mode ? styles.p_table_header_dark : ""}`}
          >
            {packingVoucherHeader?.map((h, index) => (
              <div className={styles.entry_2} key={`${h}-${index}`}>
                {h}
              </div>
            ))}
          </li>
        </div>

        {itemDetails?.map((item, index) => (
          <div className={styles.p_table_list} key={item.itemNo + "-" + index}>
            {loading ? (
              <Skeleton
                lines={itemDetails?.length === 1 ? 1 : itemDetails?.length / 2}
                thickness={5}
                additionalStyles={{ marginBottom: "0px", marginTop: "0px" }}
              />
            ) : (
              <li
                className={`${styles.p_table_row} ${mode ? styles.p_table_row_dark : ""}`}
              >
                <div className={styles.entry_2}> {index + 1} </div>
                <div className={styles.entry_2}>{item.itemNo}</div>
                <div className={styles.entry_2}> {item.product_name} </div>
                <div className={styles.entry_2}>
                  {voucherData?.warehousename}
                </div>
                <div className={styles.entry_2}>{item.qty}</div>
                <div className={styles.entry_2}> {item.unit}</div>
              </li>
            )}
          </div>
        ))}
      </ul>

      <footer className={`${styles.footer} ${mode ? styles.footer_dark : ""}`}>
        <div className={styles.footer_left}>
          <TextElement
            label={"Total Items:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={itemDetails?.length}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"400"}
          />
          <div className={styles.footer_dds}>
            <div>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                dropDownText={"Select"}
                label={"Select Packer"}
                value={selectedPM}
                options={packingManagers}
                onchange={(option) => setSelectedPM(option)}
                openUpwards={true}
                disableOpen={!isNewOrder}
              />
            </div>
            <div>
              <VerticalDropDown2
                height={"37px"}
                fontSize={"12px"}
                label={"Select Partner"}
                value={selectedPartner}
                options={filteredPartners?.map((p) => ({
                  label: p?.partnerName,
                  value: p?.contactNumber || p?.partnerName,
                }))}
                onchange={(v) => {
                  setSelectedPartner(v);

                  const foundPartner =
                    partners?.find(
                      (p) =>
                        p?.contactNumber &&
                        String(p.contactNumber) === String(v?.value),
                    ) ||
                    partners?.find(
                      (p) =>
                        p?.partnerName?.trim()?.toLowerCase() ===
                        v?.label?.trim()?.toLowerCase(),
                    );

                  setSelectedPartnerDetails(foundPartner || null);
                }}
                openUpwards={true}
                disableOpen={isDispatched || isCompleted}
              />
            </div>
          </div>
        </div>

        {!loading && (
          <div className={styles.btn_wrapper}>
            {canShowPackingSlip && (
              <MoreDropdown
                mode={mode}
                onSummaryClick={() => handlePrintClick("master")}
                onSlipClick={() => handlePrintClick("summary")}
              />
            )}

            <div>
              <Button
                buttonIcon={<LeftArrow color={"#FFFFFF"} />}
                buttonText={"Back"}
                buttonBgColor={"#000000"}
                buttonTextColor={"#ffffff"}
                buttonClick={() => navigate(-1)}
              />
            </div>

            {isNewOrder && (
              <div>
                <Button
                  buttonIcon={<TemplateDone />}
                  buttonText={"Accept"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openAcceptOrderModal}
                />
              </div>
            )}

            {(isInProgress || isPacked || isDispatched) && (
              <div>
                <Button
                  buttonIcon={<CancelIcon2 />}
                  buttonText={"Cancel Order"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openCancelOrderModal}
                />
              </div>
            )}

            {canShowPackingSlip && (
              <div>
                <Button
                  buttonIcon={<Printers color="#FFFFFF" />}
                  buttonText={"Packing Slip"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={() => handlePrintClick("slip")}
                  loading={slipLoading}
                  disabled={slipLoading}
                />
              </div>
            )}

            {isPacked && (
              <div>
                <Button
                  buttonIcon={<SideBarDeliveryIcon color="#FFFFFF" />}
                  buttonText={"Delivery Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openDeliveryDetailsModal}
                />
              </div>
            )}

            {(isDispatched || isCompleted) && (
              <div>
                <Button
                  buttonIcon={<NewEyeIcon />}
                  buttonText={"Dispatch Details"}
                  buttonBgColor={"#000000"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={() =>
                    navigate(
                      "/dispatch/prodAndSaleDetails/" +
                        orderId +
                        "/" +
                        voucherData?.warehouseId,
                    )
                  }
                />
              </div>
            )}

            {!isNewOrder && (
              <>
                {(showReqForInvoiceBtn || isSuperAdmin) && (
                  <div>
                    <Button
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#4164E3"}
                      buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
                      buttonText={"Request for Invoice"}
                      buttonClick={reqForInvoice}
                    />
                  </div>
                )}
                {showInvoiceReqSentBtn && (
                  <div>
                    <Button
                      buttonIcon={<SideBarInvoiceIcon color="#FFFFFF" />}
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#FF9B04"}
                      buttonText={"Invoice Pending"}
                    />
                  </div>
                )}
                {showDownloadInvoiceBtn && (
                  <div>
                    <Button
                      buttonTextColor={"#FFFFFF"}
                      buttonBgColor={"#4164E3"}
                      buttonIcon={<DownloadIcon />}
                      buttonText={"Download Invoice"}
                      buttonClick={openDownloadInvoiceModal}
                    />
                  </div>
                )}
              </>
            )}

            {(isPacked || isDispatched || isCompleted) && (
              <div>
                <Button
                  buttonIcon={<Printers color="#FFFFFF" />}
                  buttonText={"Label"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openPrintLabelModal}
                />
              </div>
            )}

            {isInProgress && (
              <div>
                <Button
                  buttonIcon={<Pack />}
                  buttonText={"Pack"}
                  buttonBgColor={"#4164E3"}
                  buttonTextColor={"#ffffff"}
                  buttonClick={openPackOrderModal}
                />
              </div>
            )}
          </div>
        )}
      </footer>

      <div style={{ display: "none" }}>
        <ProdAndSalePackingSlip
          ref={packingSlipRef}
          packingSlipData={packingSlipData}
          order={voucherData}
          currentWarehouse={voucherData?.warehouseId}
          filterItem={itemDetails}
          totalQty={itemDetails.length}
        />
      </div>

      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={masterSummarySlipRef}
          summarySlipData={packingSlipData}
        />
      </div>

      <div style={{ display: "none" }}>
        <NewSummarySlip
          ref={summarySlipRef}
          summarySlipData={packingSlipData}
          currentWarehouse={voucherData?.warehouseId}
          currentWarehouseName={voucherData?.warehousename}
        />
      </div>
    </div>
  );
};

export default PackingProdAndSaleVoucher;
